//save as site: {
// 1day:{}
//1hour:{}
// }
//event driven development
import { useEffect } from 'react';

import { FirebaseService } from '@flexo/general';
import { KPI, USER, ALERT } from '@flexo/reducers';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useParams } from 'react-router-dom';

const ENV = (import.meta as any).env;

const firebaseService = new FirebaseService();

export const AncillaryKpiSiteResolver = () => {
  const dispatch = useDispatch();
  const params = useParams();
  const location = useLocation();
  const metadata = useSelector((state: any) => state.metadata);
  const calendar = useSelector((state: any) => state.calendar);
  
  const pathSegment = location.pathname.split('/')[1]; 

  const { hiveCalendar } = calendar;
  const { selectedDate, selectedTimeSet} = hiveCalendar;

  async function init() {
    const idToken = await firebaseService.getIdToken();

    if (!idToken) {
      dispatch(ALERT.SetAlert({
        value: {
          type: 'BANNER_SESSION_EXPIRED',
        },
      } as any));

      // setUserStore({
      //   type: UserTypes.SetUserLogOut,
      //   payload: {
      //     value: true,
      //   },
      // });

      dispatch(USER.SetLogout());

      return;
    }

    const SITE_ID = params?.id || metadata?.selectedEntity?.siteId || null;


    if (!SITE_ID) {
      return;
    }

    dispatch(KPI.ResetNamedKpiFields([
      'AncillaryCommunity',
      'AncillaryMember',
    ] as any));
    
    dispatch(KPI.SetAncillaryKpiDataSiteAsync({ SITE_ID, idToken, selectedDate, selectedTimeSet }) as any);
  }

  useEffect(() => {
    init();
  }, [params.id, metadata?.selectedEntity, selectedDate, selectedTimeSet, pathSegment]);

  return <></>;
};
